import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  periodSections: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5rem',
    marginTop: '4rem',
  },
  sectionTitle: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 700,
    },
    letterSpacing: '0.1rem',
    color: colors.neutral[700],
    textTransform: 'uppercase',
    margin: '0 0 2rem 0',
    textAlign: 'left',
  },
  fileInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  fileItem: {
    padding: '1rem',
    minHeight: '5.6rem',
    backgroundColor: colors.blue[100],
    borderRadius: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    letterSpacing: '0.02rem',
    fontWeight: 700,
    color: colors.blue[600],
    cursor: 'pointer',
  },
  productLineFilesList: {
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
